
import { getSports } from '../../js/api/sports.js'
import { getSearchGames } from '../../js/api/search.js'
import { getSearchingGames } from "../templates/search-games.js";
import { _t } from '../../services/TranslationService.js';
import { sgGotoGame } from '../../js/api/liveCasino.js';
import IframeModal from './IframeModal.js';
import { getPokerUrl } from '../../js/constants/global-variables.js';

let sports = [];
let Leftpanel = {
    render: async () => {
        let hidePoker = true;
        // if (['mdcr7.net', '838bet.co', '838bet.net', '838bet.org', 'royal365bet.com'].indexOf(location.host) !== -1) {
        //     hidePoker = true;
        // }
        const blockedSports = JSON.parse(localStorage.getItem('blockedSports') ?? '[]');
        let sportsView = '';

        sports = await getSports();
        if (Array.isArray(sports)) {
            sports = sports.filter(sport => !blockedSports.includes(sport.id.toString()));
        } else {
            sports = [];
        }
        //console.log(sports);

        if (sports && !sports.length == 0) {
            sports.forEach(sport => {
                // <a href="#/p/${post.id}">${post.title}</a>
                sportsView = sportsView + `<a class="menuItem" href="#/categories/${sport.id}" data-id="${sport.id}">
                    ${_t(sport.name)}
                    <svg xmlns="http://www.w3.org/2000/svg" height="511pt" viewBox="0 -10 511.98685 511" width="511pt"><path d="m114.59375 491.140625c-5.609375 0-11.179688-1.75-15.933594-5.1875-8.855468-6.417969-12.992187-17.449219-10.582031-28.09375l32.9375-145.089844-111.703125-97.960937c-8.210938-7.167969-11.347656-18.519532-7.976562-28.90625 3.371093-10.367188 12.542968-17.707032 23.402343-18.710938l147.796875-13.417968 58.433594-136.746094c4.308594-10.046875 14.121094-16.535156 25.023438-16.535156 10.902343 0 20.714843 6.488281 25.023437 16.511718l58.433594 136.769532 147.773437 13.417968c10.882813.980469 20.054688 8.34375 23.425782 18.710938 3.371093 10.367187.253906 21.738281-7.957032 28.90625l-111.703125 97.941406 32.9375 145.085938c2.414063 10.667968-1.726562 21.699218-10.578125 28.097656-8.832031 6.398437-20.609375 6.890625-29.910156 1.300781l-127.445312-76.160156-127.445313 76.203125c-4.308594 2.558594-9.109375 3.863281-13.953125 3.863281zm141.398438-112.875c4.84375 0 9.640624 1.300781 13.953124 3.859375l120.277344 71.9375-31.085937-136.941406c-2.21875-9.746094 1.089843-19.921875 8.621093-26.515625l105.472657-92.5-139.542969-12.671875c-10.046875-.917969-18.6875-7.234375-22.613281-16.492188l-55.082031-129.046875-55.148438 129.066407c-3.882812 9.195312-12.523438 15.511718-22.546875 16.429687l-139.5625 12.671875 105.46875 92.5c7.554687 6.613281 10.859375 16.769531 8.621094 26.539062l-31.0625 136.9375 120.277343-71.914062c4.308594-2.558594 9.109376-3.859375 13.953126-3.859375zm-84.585938-221.847656s0 .023437-.023438.042969zm169.128906-.0625.023438.042969c0-.023438 0-.023438-.023438-.042969zm0 0"/></svg>
                    </a>`;
            });
        }

        const casinoEnabled = localStorage.getItem('casinoEnabled') === '1';
        const virtualEnabled = localStorage.getItem('virtualEnabled') === '1';
        const starCasinoEnabled = localStorage.getItem('starCasinoEnabled') === '1';
        const liveCasinoEnabled = localStorage.getItem('liveCasinoEnabled') === '1';
        const vipCasinoEnabled = localStorage.getItem('vipCasinoEnabled') === '1';
        const evoCasinoEnabled = localStorage.getItem('evoCasinoEnabled') === '1';
        const reeltrixEnabled = localStorage.getItem('reeltrixEnabled') === '1';

        let view = `
            <div class="eventShown"></div>
            <div class="searchHolder" >
                <div class="searchHeader">
                    <svg class="iconSearch" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.005 512.005" style="enable-background:new 0 0 512.005 512.005;" xml:space="preserve">
                      <g>
                          <g>
                            <path d="M505.749,475.587l-145.6-145.6c28.203-34.837,45.184-79.104,45.184-127.317c0-111.744-90.923-202.667-202.667-202.667    S0,90.925,0,202.669s90.923,202.667,202.667,202.667c48.213,0,92.48-16.981,127.317-45.184l145.6,145.6    c4.16,4.16,9.621,6.251,15.083,6.251s10.923-2.091,15.083-6.251C514.091,497.411,514.091,483.928,505.749,475.587z     M202.667,362.669c-88.235,0-160-71.765-160-160s71.765-160,160-160s160,71.765,160,160S290.901,362.669,202.667,362.669z"></path>
                          </g>
                      </g>
                    </svg>
                    <input type="text" placeholder="${_t('Kerko')}" class="searchInputLabel">
                    <div class="clearInput">
                        <span>x</span>
    <!--                        <span>loader</span>-->
                    </div>
                    <a class="closeSearch">${_t('close')}</a>
                </div>
                <div class="searchSecondHeader">
                    <span>${_t('Example Searches')}</span>
                    <a class="clearSearch">${_t('Remove All')}</a>
                </div>
                <div class="searchContent" id="searchContent">

                </div>
              </div>
              <section class="leftPanel">
                <div class="menuHolder m-t-6">
                    <div class="searchWrapper">
                        <svg class="iconSearch" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.005 512.005" style="enable-background:new 0 0 512.005 512.005;" xml:space="preserve">
                          <g>
                              <g>
                                <path d="M505.749,475.587l-145.6-145.6c28.203-34.837,45.184-79.104,45.184-127.317c0-111.744-90.923-202.667-202.667-202.667    S0,90.925,0,202.669s90.923,202.667,202.667,202.667c48.213,0,92.48-16.981,127.317-45.184l145.6,145.6    c4.16,4.16,9.621,6.251,15.083,6.251s10.923-2.091,15.083-6.251C514.091,497.411,514.091,483.928,505.749,475.587z     M202.667,362.669c-88.235,0-160-71.765-160-160s71.765-160,160-160s160,71.765,160,160S290.901,362.669,202.667,362.669z"></path>
                              </g>
                          </g>
                        </svg>
                        <input type="text" readonly placeholder="${_t('Kerko')}" id="searchTrigger">
                    </div>
                    <div class="mainLeftMenuItem">
                    <a class="leftMenuHome active" id="sportsLeftBtn">
                            <span>${_t('Sports')}</span>
                        </a>
                        <a class="leftMenuInPlay" href="#/InPlay">
                            <span>${_t('Live')}</span>
                        </a>
                        <a class="showMenuListedSlots">
                            <span>${_t('LOJRA')}</span>
                        </a>
                        ${hidePoker ? '' : `<a href="${getPokerUrl()}" target="${getPokerUrl() == '#/' ? '_self' : '_blank'}">
                            <img src="img/poker-icon.svg" alt="Poker" />
                            <span>${_t('Poker')}</span>
                        </a>`}
                    </div>
                    <div class="menuItemListed active">
                        <a class="menuItem homeLeftBtn" href="~/../">${_t('Home')}</a>
                        ${sportsView}
                    </div>
                    <div class="slotsItemListed">
                        <a class="slotItemList" href="#/reeltrix" ${reeltrixEnabled ? '' : 'hidden'}>
                            <img src="img/reeltrix-casino.webp" alt="Reeltrix Casino" />
                            <span>Casino VIP</span>
                        </a>
                        <a class="slotItemList" href="#/slots" ${casinoEnabled ? '' : 'hidden'}>
                            <img src="img/game1.jpeg" alt="">
                            <span>${_t('Vegas Casino')}</span>
                        </a>
                        <a class="slotItemList" href="#/live-casino" ${liveCasinoEnabled ? '' : 'hidden'}>
                            <img src="img/game2.jpeg" alt="">
                            <span>${_t('Live Casino')}</span>
                        </a>
                        <a class="slotItemList" href="#/evo-casino" ${evoCasinoEnabled ? '' : 'hidden'}>
                            <img src="img/evo-casino.png" alt="Evolution Gaming" style="object-fit: contain" />
                            <span>Evo Casino</span>
                        </a>
                        <a class="slotItemList" href="#/stargames" ${vipCasinoEnabled ? '' : 'hidden'}>
                            <img src="img/game7.jpeg" alt="">
                            <span>VIP Casino</span>
                        </a>
                        <a class="slotItemList leftPanel-game" game="4999" ${vipCasinoEnabled ? '' : 'hidden'}>
                            <img src="https://content.stargame.solutions/api/game/icon2/4999" alt="Uncrossable Rush" />
                            <span>Uncrossable Rush</span>
                        </a>
                        <a class="slotItemList" href="#/deluxe" ${starCasinoEnabled ? '' : 'hidden'}>
                            <img src="img/game3.jpg" alt="">
                            <span>${_t('GS Deluxe')}</span>
                        </a>
                        <a class="slotItemList" onclick="launchvirtualgames()" ${virtualEnabled ? '' : 'hidden'}>
                            <img src="img/game4.jpeg" alt="">
                            <span>${_t('Virtuale')}</span>
                        </a>
                        <a class="slotItemList rouletteBtn" hidden>
                            <img src="/vbet/user/src/img/games_icons/LuxRoulette.jpg" alt="">
                            <span>${_t('Roulette')}</span>
                        </a>
                        <!-- <a class="slotItemList" href="#/slots" hidden>
                            <img src="/vbet/user/src/img/games_icons/GrandX.jpg" alt="">
                            <span>${_t('Fast money')}</span>
                        </a> -->
                        <a class="slotItemList leftPanel-game" game="2046" ${starCasinoEnabled ? '' : 'hidden'}>
                            <img src="img/game5.jpeg?v=1" alt="Aviator" />
                            <span>${_t('Aviator')}</span>
                        </a>
                        <a class="slotItemList leftPanel-game" game="2044" ${vipCasinoEnabled ? '' : 'hidden'}>
                            <img src="img/game6.webp" alt="Plinko Dare2Win" />
                            <span>Plinko Dare2Win</span>
                        </a>
                        <a class="slotItemList leftPanel-game" game="949" ${vipCasinoEnabled ? '' : 'hidden'}>
                            <img src="https://content.stargame.solutions/api/game/icon2/949" alt="BONUS" />
                            <span>${_t('luckybonus')}</span>
                        </a>
                    </div>
                </div>
              </section>
        `
        return view
    },
    after_render: async () => {

        $('body').on('click', '#searchTrigger', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $('body').addClass('showDescSearch');
            $('body .searchHolder').addClass('show');
            $('body .searchInputLabel').focus();
        });

        $('body').on('click', '.closeSearch', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $('body').removeClass('showDescSearch');
            $('body .searchHolder').removeClass('show');
            $('body .clearSearch').click();
        });

        $('body').on('click', '.clearSearch', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $('body .searchInputLabel').val('');
            document.getElementById('searchContent').innerHTML = '';
        });

        $('body').on('click', '.clearInput', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $('body .searchInputLabel').val('');
            $('body .searchInputLabel').focus();
        });

        $(".leftPanel-game").on("click", async function (e) {
            if (
                !localStorage.getItem("access_token") ||
                localStorage.getItem("access_token") == ""
            ) {
                alert("Login!");
                return;
            }

            if (localStorage.getItem('vipCasinoEnabled') != "1") {
                alert("Nuk keni qasje ne lojet e Casino!");
                return;
            }

            let checkStatus = await sgGotoGame();
            let key1 = checkStatus.key1;
            let key2 = checkStatus.key2;
            let sessionid = checkStatus.sessionid;
            let userId = localStorage.getItem('user_id');

            let gameId = $(e.currentTarget).attr('game');
            let gameName = $(e.currentTarget).children('span').text();

            const gameLink = `https://apiserver.solutions/showgame?gameid=${gameId}&sid=${sessionid}&key1=${key1}&key2=${key2}&username=${userId}&uwidth=auto&uheight=auto`;

            IframeModal.loadIframe(gameLink, true);
            IframeModal.show(gameName);
        });

        $("body .searchInputLabel").on('keyup', delay(async function (e) {

            let getSearchValue = e.currentTarget.value;
            let searchView = '';

            if (e.currentTarget.value.length >= 3) {
                let searchValues = await getSearchGames(getSearchValue);
                if (!searchValues.length == 0) {
                    const uniqueDates = [
                        ...new Set(searchValues.map((item) => item.game_date)),
                    ].sort();

                    let searchGamesView = "";

                    uniqueDates.forEach((date) => {
                        let singleDateView = "";

                        searchValues
                            .filter((a) => a.game_date === date)
                            .map((searchValue) => {
                                if (!searchValue.odd || searchValue.id == 372481) {
                                    return;
                                }
                                singleDateView += getSearchingGames(searchValue);
                            });

                        if (singleDateView == "") {
                            return;
                        } else {
                            searchGamesView =
                                searchGamesView +
                                ` <div class="searchLabelGroup">
                            <div class="searchLabel">
                               <span>${date}</span>
                            </div>
                            <div class="search-games">
                              ${singleDateView}
                            </div>
                        </div>`;
                        }
                    });
                    $('body #searchContent').html(searchGamesView);
                }
            }
            if (e.currentTarget.value.length == 0) {
                $('body .clearSearch').click();
            }
        }, 500));
        function delay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this, args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        }

        $('body').on('click', '.showMenuListedSlots', function (e) {
            $(e.currentTarget).parent().children().removeClass('active');
            $(e.currentTarget).addClass('active');

            $('body .slotsItemListed').addClass('active');
            $('body .menuItemListed').removeClass('active');
        });

        $('body').on('click', '#sportsLeftBtn', function (e) {
            $(e.currentTarget).parent().children().removeClass('active');
            $(e.currentTarget).addClass('active');
            $('body .menuItemListed').addClass('active');
            $('body .slotsItemListed').removeClass('active');
        });

        $('body').on('click', '.slotItemList', function (e) {
            $('.profileNav a').removeClass('active');
            $('.mainMenuHolder a').removeClass('active');
            $('body').removeClass('menuOpened');
        });
        $('body').on('click', '.leftMenuInPlay', function (e) {
            $('body').removeClass('menuOpened');
        });


    }
};

export { Leftpanel, sports };